module.exports = __webpack_public_path__ + "1880c8726cb110173701b6478406cbea.svg";